import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "max-size center",
  style: {"max-width":"v-bind(cardHeight)","max-height":"v-bind(cardHeight)"}
}

import { IonCol, IonRow } from "@ionic/vue";
import { Supplier } from "@/types/supplier";
import ImageSupplier from "@/components/image/ImageSupplier.vue";
import { computed } from "vue";
import { useSupplierStore } from "@/stores/suppliers";

const cardHeight = '50px'


export default /*@__PURE__*/_defineComponent({
  __name: 'CardDelivererReduced',
  props: {
    supplier: {},
    supplierId: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v095b4c30": (cardHeight)
}))

const props = __props
const supplierStore = useSupplierStore()

const internalSupplier = computed<Supplier>(() => {
    if (props.supplier) return props.supplier

    if (!props.supplierId) return {} as Supplier

    return supplierStore.supplierById(props.supplierId) ?? {} as Supplier
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonCol), {
      size: "auto",
      class: "center py-0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ImageSupplier, {
            "supplier-id": internalSupplier.value.id,
            class: "contain-supplier-image"
          }, null, 8, ["supplier-id"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonCol), { class: "py-0 center-x flex-d-c" }, {
      default: _withCtx(() => [
        (internalSupplier.value.city)
          ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "coral-coral-color" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(internalSupplier.value.city), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "purple-purple-color fw-b" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(internalSupplier.value.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})